/**
 * `Activities.outcome` bei `activityType: "call"` — das Anrufergebnis (CRM E-II).
 *
 * Gespeichert wird der CODE ("1" … "9") als String, wie die uebrigen Status im
 * Dashboard: `outcome` ist im Schema ein String, eine Zahl braeuchte einen
 * Schema-Wechsel und einen Push. Gefiltert wird damit ueber `outcome: { eq: "2" }`.
 *
 * `label` ist HubSpots deutscher Text. Er hat zwei Aufgaben und darf deshalb nicht
 * frei umformuliert werden:
 *   1. Schluessel fuer t() — die Uebersetzungen stehen in locales/*\/components.json,
 *   2. Abbildung im Migrationsscript, das HubSpots Disposition-Labels auf den Code
 *      dreht (scripts/crm-migration.js liest dieselbe JSON).
 *
 * `offered: false` sind die zwei praktisch ungenutzten Werte (33 von 14.318): sie
 * werden migriert und angezeigt, aber nicht mehr zur Auswahl gestellt.
 *
 * "KD" = Kontaktdaten/Kunde: ob im Gespraech der Kunde bzw. der Einkauf selbst am
 * Apparat war oder nur die Zentrale.
 */
import outcomes from "./callOutcomes.json";

export const CALL_OUTCOMES = outcomes;

// Angeboten wird die kurze Liste, angezeigt werden alle — auch die migrierten.
export const CALL_OUTCOMES_OFFERED = outcomes.filter((o) => o.offered);

const byCode = Object.fromEntries(outcomes.map((o) => [o.code, o.label]));
const groupByCode = Object.fromEntries(outcomes.map((o) => [o.code, o.group]));
const byLabel = Object.fromEntries(outcomes.map((o) => [o.label, o.code]));

// Unbekanntes kommt unveraendert zurueck: Altbestand trug den deutschen Text
// direkt im Feld, und ein leeres Etikett waere schlimmer als ein rohes.
export const callOutcomeLabel = (code) => byCode[code] || code || "";

// Nur fuer Altwerte gedacht (Text -> Code); neue Anrufe schreiben den Code direkt.
export const callOutcomeCode = (label) => byLabel[label] || "";

// Hat der Anruf niemanden erreicht? Dann bleibt die Aufgabe, aus der er entstand,
// OFFEN — der Anruf haengt trotzdem an ihr (Tasks.activityIDs). Unbekanntes gilt als
// erreicht: Altbestand trug den deutschen Text im Feld, und eine Aufgabe faelschlich
// offen zu lassen waere die schlechtere Annahme.
export const callOutcomeNotReached = (code) => groupByCode[code] === "notReached";
